import { render, staticRenderFns } from "./TabPanesHorizontal.vue?vue&type=template&id=8bd7cbd6"
import script from "./TabPanesHorizontal.vue?vue&type=script&lang=js"
export * from "./TabPanesHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports